module.exports = __webpack_public_path__ + "static/media/Book.c8961806.svg";